export function cached<T>(ttlMs: number) {
  const values = new Map<string, { at: number; value: T }>();
  const inflight = new Map<string, Promise<T>>();
  let gen = 0;
  return {
    get(key: string, load: () => Promise<T>): Promise<T> {
      const hit = values.get(key);
      if (hit && Date.now() - hit.at < ttlMs) return Promise.resolve(hit.value);
      const existing = inflight.get(key);
      if (existing) return existing;
      const g = gen;
      const flight: Promise<T> = load()
        .then((value) => {
          if (g === gen) values.set(key, { at: Date.now(), value });
          return value;
        })
        .finally(() => {
          if (inflight.get(key) === flight) inflight.delete(key);
        });
      inflight.set(key, flight);
      return flight;
    },
    put(key: string, value: T): void {
      values.set(key, { at: Date.now(), value });
    },
    invalidate(): void {
      gen++;
      values.clear();
      inflight.clear();
    },
  };
}
